import { FiX } from "react-icons/fi";
import PortalSearchInput from "components/v2/PortalSearchInput";
import useInitialQueryData from "./useInitialQueryData";

/**
 * @typedef {Object} SearchProps
 * @property {Object} filters
 * @property {Object} formData
 * @property {string} placeholder
 *
 * @param {SearchProps} props
 */
const Search = (props) => {
	const { filters, formData, placeholder } = props;

	const { filterValues, setFilterValues } = useInitialQueryData(filters, formData);

	const changeInputValue = (e) => {
		const value = e.target?.value;
		setFilterValues((prev) => ({ ...prev, [e.target.name]: value }));
	};

	const handleSearch = (e) => {
		e.preventDefault();
		filters?.changeAllFiltersAtOnce(filterValues);
	};

	const clearSearchTerm = () => {
		setFilterValues({ ...filterValues, search: "" });
		if (filters?.search) {
			filters?.changeAllFiltersAtOnce({ ...filterValues, search: "" });
		}
	};

	return (
		<form className="portal-filter-search portal-search-form" onSubmit={handleSearch}>
			<PortalSearchInput
				name="search"
                aria-label={placeholder || "Search title, author, ISBN or keyword"}
				type="text"
				value={filterValues.search}
				onChange={changeInputValue}
				// placeholder="Search title, author, ISBN, keyword, etc..."
				placeholder={placeholder || "Search title, author, ISBN, keyword, etc..."}
			/>

			<div
				className="portal-search-actions"
				hidden={!filterValues?.search}
			>
				<button type="button" className="portal-icon-button" aria-label="Clear search" onClick={clearSearchTerm}>
					<FiX size={20} />
				</button>
				<button type="submit" className="portal-button portal-button-primary">
					Search
				</button>
			</div>
		</form>
	);
};

export default Search;
